import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: null,
  students: [],
};

const slice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET student
    getstudentSuccess(state, action) {
      state.isLoading = false;
      state.students = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;


export function getStudents(role, paginate, pageIndex, pageSize) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const params = {};
      if (paginate) params.paginate = paginate;
      if (pageIndex) params.page = pageIndex;
      if (pageSize) params.per_page = pageSize;
      const response = await axios.get(`/api/${role}/students`, { params });
      dispatch(slice.actions.getstudentSuccess(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
